import React from 'react';
import styled from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';
import SGTitle from '../../Typography/SGTitle';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 250px;
  flex-direction: column;
`;

const StyledLoadingText = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-bottom: 0.5rem;
`;

const StyledLinearProgress = styled(LinearProgress)`
  width: 80%;
  border-radius: 5px;
  &.MuiLinearProgress-root {
    height: 10px;
  }
  &.MuiLinearProgress-colorPrimary {
    background-color: ${props => props.theme.text}11;
  }
  .MuiLinearProgress-bar1Buffer {
    background-color: ${props => props.theme.text}33;
  }
  .MuiLinearProgress-bar2Buffer {
    background-color: ${props => props.theme.text}22;
  }
  .MuiLinearProgress-dashedColorPrimary {
    background-size: 500px 10px;
    background-image: linear-gradient(
      90deg,
      transparent,
      ${props => props.theme.text}22,
      transparent
    );
  }
`;

const renderLoadingSteps = function renderLoadingSteps(percentage) {
  const x = Math.round(percentage);
  if (x < 10) {
    return 1;
  } else if (x >= 10 && x < 20) {
    return 2;
  } else if (x >= 20 && x < 30) {
    return 3;
  } else if (x >= 30 && x < 40) {
    return 4;
  } else if (x >= 40 && x < 50) {
    return 5;
  } else if (x >= 50 && x < 60) {
    return 6;
  } else if (x >= 60 && x < 70) {
    return 7;
  } else if (x >= 70 && x < 80) {
    return 8;
  } else if (x >= 80 && x < 90) {
    return 9;
  } else {
    return 10;
  }
};

export default function LinearBuffer() {
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);

  const progressRef = React.useRef(() => {});
  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <StyledContainer>
      <StyledLoadingText>
        <SGTitle variant={'t4'} className={'text-color'}>
          LOADING FROM [DATA SOURCE {renderLoadingSteps(progress)}]
        </SGTitle>
        <SGTitle variant={'t4'} className={'text-color'}>
          {renderLoadingSteps(progress)} OUT OF 10
        </SGTitle>
      </StyledLoadingText>
      <StyledLinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
    </StyledContainer>
  );
}
